import { MainTemplate } from "@/components/templates";
import { css } from "@emotion/react";
import { TermsOfIDPackageContent } from "@/components/atoms";
import { useIsSpMode } from "@/hooks";

export const TermsOfIDPage = () => {
  const isSpMode = useIsSpMode();

  return (
    <MainTemplate term={true} title={"利用規約"}>
      <h2 css={!isSpMode ? title : spModeTitle}>Mikatano ID利用規約</h2>
      <TermsOfIDPackageContent />
    </MainTemplate>
  );
};

const title = css({
  margin: "auto",
  width: "703px",
  fontWeight: "bold",
  marginBottom: "20px",
});

const spModeTitle = css({
  margin: "auto",
  fontWeight: "bold",
  marginBottom: "20px",
});
